import { defineMessages } from 'react-intl';

export default defineMessages({
	amountTitle: {
		id: 'pages.walletPayment.paymentInformation.amountTitle',
		defaultMessage: 'مبلغ فاکتور:',
	},
	description: {
		id: 'pages.walletPayment.paymentInformation.description',
		defaultMessage:
			'را به مشتری اعلام کنید. سپس بارکد کیف پول مشتری را اسکن کنید تا پرداخت انجام شود.',
	},
	boldDescription: {
		id: 'pages.walletPayment.paymentInformation.boldDescription',
		defaultMessage: 'مبلغ فاکتور',
	},
	nextStepButton: {
		id: 'pages.walletPayment.paymentInformation.nextStepButton',
		defaultMessage: 'اسکن بارکد',
	},
	backButton: {
		id: 'pages.walletPayment.paymentInformation.backButton',
		defaultMessage: 'ویرایش مبلغ',
	},
});
